import MenuItem from './MenuItem';

export default function CategorySection({ category, onItemClick }) {
  return (
    <div id={`category-${category.id}`} className="mb-8 scroll-mt-32">
      <div className="mb-4">
        <h2 className="text-xl md:text-2xl font-bold text-gray-900">
          {category.name}
        </h2>
        {category.description && (
          <p className="text-sm text-gray-600 mt-1">
            {category.description}
          </p>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {category.items.map((item) => (
          <MenuItem 
            key={item.id} 
            item={item} 
            onClick={onItemClick}
          />
        ))}
      </div>
    </div>
  );
}
